/* CONIUNCTA Industrieanfrage: Mengenpruefung, Referenz-Variante, Panel-Steuerung.
   Gehoert zu snippets/coni-industrieanfrage.liquid. Keine Abhaengigkeiten. */
(function () {
  'use strict';

  function track(name, params) {
    try {
      window.dataLayer = window.dataLayer || [];
      var ev = { event: name };
      for (var k in params) { if (params[k] !== undefined && params[k] !== null && params[k] !== '') ev[k] = params[k]; }
      window.dataLayer.push(ev);
    } catch (e) { /* Tracking optional */ }
  }

  function parseNum(v) {
    var n = parseFloat(String(v == null ? '' : v).replace(',', '.'));
    return isNaN(n) ? null : n;
  }

  function init(root) {
    if (root.dataset.coniIaReady) return;
    root.dataset.coniIaReady = '1';

    var details = root.querySelector('details');
    var minKg = parseNum(root.dataset.minKg);
    if (minKg == null) minKg = 5;
    var form = root.querySelector('form');
    var hasStatus = root.querySelector('.coni-ia__errors, .coni-ia__success');
    var wantsOpen = window.location.hash === '#industrieanfrage' || /contact_posted=true/.test(window.location.search);

    var produkt = root.dataset.productHandle || '';
    var status = root.dataset.status || '';
    if (details) {
      details.addEventListener('toggle', function () {
        if (!details.open) return;
        // automatisches Aufklappen (Desktop) nicht als Nutzeraktion zaehlen
        if (details.dataset.autoOpened) { delete details.dataset.autoOpened; return; }
        track('industrieanfrage_oeffnen', { produkt: produkt, status: status });
      });
    }
    if (details && (hasStatus || wantsOpen)) details.open = true;
    // Grosse Bildschirme (zweispaltiges Produktlayout ab 1024 px): Panel standardmaessig offen, mobil eingeklappt.
    if (details && !details.open && window.matchMedia && window.matchMedia('(min-width: 1024px)').matches) {
      details.dataset.autoOpened = '1';
      details.open = true;
    }
    if (wantsOpen) {
      window.setTimeout(function () {
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 150);
    }
    // Anker-Links innerhalb der Seite (#industrieanfrage) oeffnen das Panel.
    window.addEventListener('hashchange', function () {
      if (window.location.hash === '#industrieanfrage' && details) {
        details.open = true;
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });

    // Gast: der von BSS ausgegraute Kaufbutton heisst „Zum Bestellen anmelden" und fuehrt zum Login
    // (Ruecksprung auf dieses Produkt). Klick per Delegation, Beschriftung per Observer, damit beides
    // auch nach Variantenwechseln des Themes bestehen bleibt.
    if (root.dataset.loginUrl) {
      var scope = root.closest('product-info') || document;
      var label = root.dataset.loginTitle || '';
      var relabel = function () {
        Array.prototype.forEach.call(scope.querySelectorAll('[id*="ProductSubmitButton"]'), function (btn) {
          if (!label) return;
          var t = btn.querySelector('.btn__text') || btn;
          if (t.textContent.trim() !== label) t.textContent = label;
          if (btn.title !== label) { btn.title = label; btn.setAttribute('aria-label', label); }
        });
      };
      relabel();
      scope.addEventListener('click', function (ev) {
        if (!ev.target || !ev.target.closest) return;
        var btn = ev.target.closest('[id*="ProductSubmitButton"]');
        if (btn) {
          ev.preventDefault();
          ev.stopImmediatePropagation();
          track('login_aufforderung', { quelle: 'kaufbutton', produkt: produkt });
          window.location.href = root.dataset.loginUrl;
          return;
        }
        if (ev.target.closest('.product__block--price .bss-login-link')) {
          track('login_aufforderung', { quelle: 'preis', produkt: produkt });
        }
      }, true);
      Array.prototype.forEach.call(root.querySelectorAll('.coni-ia__actions a'), function (a, i) {
        a.addEventListener('click', function () {
          track('login_aufforderung', { quelle: i === 0 ? 'industrieanfrage_anmelden' : 'industrieanfrage_registrieren', produkt: produkt });
        });
      });
      if (window.MutationObserver) {
        new MutationObserver(relabel).observe(scope, { childList: true, subtree: true, characterData: true });
      }
    }

    if (!form) return;

    var qty = form.querySelector('[data-coni-ia="qty"]');
    var qtyErr = form.querySelector('[data-coni-ia="qty-error"]');
    var chips = Array.prototype.slice.call(form.querySelectorAll('.coni-ia__chip'));

    function validateQty(showEmpty) {
      var v = parseNum(qty.value);
      var ok = v != null && v > minKg;
      var empty = qty.value === '';
      if (qtyErr) qtyErr.hidden = ok || (empty && !showEmpty);
      qty.classList.toggle('is-invalid', !ok && (!empty || showEmpty));
      qty.setCustomValidity(ok ? '' : (qtyErr ? qtyErr.textContent.trim() : 'min'));
      chips.forEach(function (c) { c.classList.toggle('is-active', parseNum(c.dataset.kg) === v); });
      return ok;
    }
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        qty.value = c.dataset.kg;
        validateQty(false);
        qty.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    qty.addEventListener('input', function () { validateQty(false); });
    qty.addEventListener('blur', function () { if (qty.value !== '') validateQty(false); });

    // Referenz-Variante/SKU: groesstes Gebinde der gewaehlten Basis und Qualitaet (Bio = SKU mit -BIO).
    var variants = [];
    var vnode = root.querySelector('[data-coni-ia="variants"]');
    if (vnode) { try { variants = JSON.parse(vnode.textContent) || []; } catch (e) { variants = []; } }
    // Entwicklungsmuster (SKU-Suffix -EM) sind keine Referenz fuer Industriemengen.
    variants = variants.filter(function (v) { return !/-EM$/.test(String(v.sku || '')); });
    var baseSelects = Array.prototype.slice.call(form.querySelectorAll('[data-coni-ia="base"], [data-coni-ia="quality"]'));
    var refTitle = form.querySelector('[data-coni-ia="variant-title"]');
    var refSku = form.querySelector('[data-coni-ia="variant-sku"]');

    function currentVariantId() {
      var pf = document.getElementById(root.dataset.productForm);
      var inp = pf ? pf.querySelector('input[name="id"]') : document.querySelector('form[action*="/cart/add"] input[name="id"]');
      var id = inp ? parseInt(inp.value, 10) : NaN;
      return isNaN(id) ? null : id;
    }
    function updateRef() {
      if (!variants.length || !refTitle) return;
      var cands = variants;
      var picked = baseSelects.map(function (s) { return s.value; }).filter(Boolean);
      var known = picked.filter(function (val) { return variants.some(function (v) { return v.options.indexOf(val) !== -1; }); });
      if (known.length) {
        cands = variants.filter(function (v) { return known.every(function (val) { return v.options.indexOf(val) !== -1; }); });
      } else if (!picked.length) {
        var cur = currentVariantId();
        var cv = variants.filter(function (v) { return v.id === cur; });
        if (cv.length) cands = cv;
      }
      if (!cands.length) cands = variants;
      var best = cands.slice().sort(function (a, b) { return (b.grams || 0) - (a.grams || 0); })[0];
      refTitle.value = best.title || '';
      if (refSku) refSku.value = best.sku || '';
    }
    baseSelects.forEach(function (s) { s.addEventListener('change', updateRef); });

    // Variantenwechsel im Theme (Hyper/FoxTheme pubsub) nachfuehren.
    try {
      if (window.FoxTheme && FoxTheme.pubsub && typeof FoxTheme.pubsub.subscribe === 'function') {
        FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, function (e) {
          var d = e && e.data ? e.data : e;
          if (!d || !d.variant) return;
          if (d.sectionId && root.dataset.sectionId && d.sectionId !== root.dataset.sectionId) return;
          baseSelects.forEach(function (s) {
            for (var i = 0; i < s.options.length; i++) {
              if (d.variant.options && d.variant.options.indexOf(s.options[i].value) !== -1) { s.value = s.options[i].value; break; }
            }
          });
          updateRef();
          if (typeof syncUsda === 'function') syncUsda();
        });
      }
    } catch (e) { /* ohne pubsub: Referenz bleibt Stand beim Laden */ }
    updateRef();

    // Qualitaet: Select aus der Produktoption "Qualität" (Bio = Wert mit "IFOAM"); USDA-Option nur bei Bio.
    var qualitySelect = form.querySelector('[data-coni-ia="quality"]');
    var usdaBox = form.querySelector('[data-coni-ia="usda"]');
    function isBioValue(v) { return /IFOAM|^Bio/i.test(String(v || '')); }
    function syncUsda() {
      if (!usdaBox) return;
      var isBio = !!qualitySelect && isBioValue(qualitySelect.value);
      usdaBox.hidden = !isBio;
      if (!isBio) { var cb = usdaBox.querySelector('input[type="checkbox"]'); if (cb) cb.checked = false; }
    }
    if (qualitySelect) qualitySelect.addEventListener('change', syncUsda);
    syncUsda();

    var started = false;
    form.addEventListener('input', function () {
      if (started) return;
      started = true;
      track('industrieanfrage_start', { produkt: produkt });
    });

    function qualityValue() {
      if (!qualitySelect) return 'konventionell';
      return isBioValue(qualitySelect.value) ? 'bio' : 'konventionell';
    }

    form.addEventListener('submit', function (ev) {
      if (!validateQty(true)) {
        ev.preventDefault();
        if (details) details.open = true;
        qty.focus();
        return;
      }
      // Kontext an die Danke-Seite haengen (Conversion mit Produkt, Menge, Qualitaet)
      var rt = form.querySelector('[data-coni-ia="return-to"]');
      if (rt && rt.value.indexOf('&menge=') === -1) {
        rt.value += '&menge=' + encodeURIComponent(String(parseNum(qty.value) || '')) + '&qualitaet=' + encodeURIComponent(qualityValue());
      }
      // Nicht per disabled sperren: Shopifys hCaptcha-Skript faengt den Submit ab und loest ihn
      // danach mit demselben Button erneut aus. Doppelklicks nur optisch/per Klasse abfangen.
      var btn = form.querySelector('[type="submit"]');
      if (btn) { btn.classList.add('is-submitting'); btn.setAttribute('aria-busy', 'true'); }
      if (!root.dataset.iaSubmitTracked) {
        root.dataset.iaSubmitTracked = '1';
        var demand = form.querySelector('#' + form.id + '-demand');
        var base = form.querySelector('[data-coni-ia="base"]');
        track('industrieanfrage_submit', { produkt: produkt, menge_kg: parseNum(qty.value), qualitaet: qualityValue(),
          bedarf: demand ? demand.value : '', basis: base ? base.value : '' });
      }
    });
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('.coni-ia'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
